import axios from 'axios';
import user from  '../utils/user';

export default {
  async getAllSendConfigs() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/integrations/sendconfigs`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async saveIntegrationParameters(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/suppliers/companySuppliersParameters`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async updateSendConfigs(payload) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/integrations/sendconfigs`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
